// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_layout_header {
  background-color: #140f2d !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: -1px;
  z-index: 999;
}

.user_layout_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.user_layout_logo_container {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.user_layout_search_container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user_layout_menu_container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
}

.user_layout_drawer_container {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.user_layout_search_input {
  border-radius: 16px;
  border: 1px solid white;
  background-color: transparent !important ;
  color: white;
  width: 90%;
}

.drawer_menu_icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.menu-container a:hover {
  color: #f0f1f3;
}
.user_layout_menus {
  text-decoration: none;
  color: white;
  cursor: pointer;
}

.desktop_header_search
  > .ant-input-wrapper
  > .ant-input-affix-wrapper
  > input.ant-input {
  background-color: rgb(0, 255, 72) !important;
  color: #f1f2f3 !important;
}

.header_search_icon {
  color: #ffff;
  margin-top: 5px;
}

.header_drawer {
  background: linear-gradient(
    166.4deg,
    #140f2d 9.74%,
    #f49d36 281.54%
  ) !important;
  overflow: hidden;
  width: "100%";
  border-color: none !important;
}

.drawer_menu_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.ant-drawer-header {
  display: none !important;
}
.ant-drawer-mask {
  background: none !important;
}
.user_layout_logo {
  object-fit: contain;
  cursor: pointer;
}

.User_login_button_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 20%;
}

.User_login_button {
  background: linear-gradient(
    166.4deg,
    #140f2d 9.74%,
    #f49d36 281.54%
  ) !important;
  color: white;
}
.drawer_user_detail_container {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.drawer_user_name_container {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.drawer_user_profile_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 15% !important;
  height: 100%;
}
.drawer_welcome_container {
  height: 100%;
  color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 65% !important;
  margin-left: 7px;
}
.drawer_user_name_text {
  color: white;
}
.drawer_line {
  background-color: white !important;
  margin-top: 10px;
  margin-bottom: 15px;
  height: 1px;
  width: 100%;
}
.header_drawer_social_media_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header_drawer_social_media_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header_drawer_social_small_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.quick_access_container {
  height: 45px;
  width: 100%;
  display: flex;
  background-color: #140f2d !important;
  justify-content: center;
  align-items: center;
}
.quick_access_wrapper {
  height: 80%;
  width: 95%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.quick_access_bookmark_container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.quick_access_language_container {
  width: 13%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quick_access_theme_container {
  width: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.quick_access_theme_icon {
  color: white;
}
.footer_main_container {
  display: grid;
  grid-template-columns: 33.3% 33.3% 33.3%;
  padding: 20px;
}
.footer_first_column_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
.footer_first_column_footer_logo_image {
  width: 60%;
  cursor: pointer;
}

.footer_first_column_signatory_image {
  width: 25%;
  cursor: pointer;
}

.footer_second_page_column_container {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 10px;
  padding-top: 14px;
}
.quick_access_label_container {
  list-style-type: none;
  font-family: "Lato";
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.quick_access_label {
  font-size: 18px;
}

.quick_access_label:hover {
  color: #3498db !important;
  text-decoration: underline !important;
}
.main_header {
  font-size: 17px;
  font-family: "kufam";
  font-weight: bold;
}
.image_box {
  width: 25px;
}
.footer-logo {
  width: 100%;
  cursor: pointer;
}
.footer_third_column_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 13px;
}
.footer_third_column_image_container {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.social_media_tag {
  font-size: 18px;
}
.copy_right_container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.social_media_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.copy_right_text {
  font-size: 8px;
  font-family: "Kufam";
}
.footer_mobile_view_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}
.footer_mobile_second_column_container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 30px;
}
.footer_mobile_third_column_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.drawer_close_icon {
  height: 15px;
  cursor: pointer;
}
.header_drawer_theme {
  height: 55px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer_page_menus {
  all: unset;
  cursor: pointer;
}
.user_profile_container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.user_profile {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.lite_mode {
  color: #fff;
  font-weight: 600;
}
.black_text {
  color: #111;
  font-weight: 600;
}

.quick_access_bookmark_text {
  cursor: pointer;
  color: #fff; /* Default text color */
}

.quick_access_bookmark_text.selected {
  font-weight: bold;
  color: #f49d36; /* Change color to indicate selection */
}
.language_divider {
  color: #fff;
  padding-left: 5px;
  padding-right: 5px;
}
.drawer_user_profile {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  cursor: pointer;
  object-fit: cover;
}

.main_menu {
  color: white !important;
  width: 100%;
  background-color: transparent;
  display: flex;
  justify-content: end;
}

.segment_container {
  display: flex;
  align-items: center;
  width: 190px;
}

.bookmarks-submenu .ant-menu-title-content {
  color: #ffffff !important;
}

.submit_claim_modal > div > .ant-modal-content {
  padding: 0px !important;
}
.header_drawer_close_container {
  height: 6%;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_layout.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;;;cAIY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;;;;cAIY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW,EAAE,uBAAuB;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,uCAAuC;AACzD;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".user_layout_header {\n  background-color: #140f2d !important;\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: sticky;\n  top: -1px;\n  z-index: 999;\n}\n\n.user_layout_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.user_layout_logo_container {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.user_layout_search_container {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.user_layout_menu_container {\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.user_layout_drawer_container {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.user_layout_search_input {\n  border-radius: 16px;\n  border: 1px solid white;\n  background-color: transparent !important ;\n  color: white;\n  width: 90%;\n}\n\n.drawer_menu_icon {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.menu-container a:hover {\n  color: #f0f1f3;\n}\n.user_layout_menus {\n  text-decoration: none;\n  color: white;\n  cursor: pointer;\n}\n\n.desktop_header_search\n  > .ant-input-wrapper\n  > .ant-input-affix-wrapper\n  > input.ant-input {\n  background-color: rgb(0, 255, 72) !important;\n  color: #f1f2f3 !important;\n}\n\n.header_search_icon {\n  color: #ffff;\n  margin-top: 5px;\n}\n\n.header_drawer {\n  background: linear-gradient(\n    166.4deg,\n    #140f2d 9.74%,\n    #f49d36 281.54%\n  ) !important;\n  overflow: hidden;\n  width: \"100%\";\n  border-color: none !important;\n}\n\n.drawer_menu_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n.ant-drawer-header {\n  display: none !important;\n}\n.ant-drawer-mask {\n  background: none !important;\n}\n.user_layout_logo {\n  object-fit: contain;\n  cursor: pointer;\n}\n\n.User_login_button_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%;\n  width: 20%;\n}\n\n.User_login_button {\n  background: linear-gradient(\n    166.4deg,\n    #140f2d 9.74%,\n    #f49d36 281.54%\n  ) !important;\n  color: white;\n}\n.drawer_user_detail_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.drawer_user_name_container {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.drawer_user_profile_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 15% !important;\n  height: 100%;\n}\n.drawer_welcome_container {\n  height: 100%;\n  color: white;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 65% !important;\n  margin-left: 7px;\n}\n.drawer_user_name_text {\n  color: white;\n}\n.drawer_line {\n  background-color: white !important;\n  margin-top: 10px;\n  margin-bottom: 15px;\n  height: 1px;\n  width: 100%;\n}\n.header_drawer_social_media_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.header_drawer_social_media_wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header_drawer_social_small_wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.quick_access_container {\n  height: 45px;\n  width: 100%;\n  display: flex;\n  background-color: #140f2d !important;\n  justify-content: center;\n  align-items: center;\n}\n.quick_access_wrapper {\n  height: 80%;\n  width: 95%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.quick_access_bookmark_container {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.quick_access_language_container {\n  width: 13%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quick_access_theme_container {\n  width: 40px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.quick_access_theme_icon {\n  color: white;\n}\n.footer_main_container {\n  display: grid;\n  grid-template-columns: 33.3% 33.3% 33.3%;\n  padding: 20px;\n}\n.footer_first_column_container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n.footer_first_column_footer_logo_image {\n  width: 60%;\n  cursor: pointer;\n}\n\n.footer_first_column_signatory_image {\n  width: 25%;\n  cursor: pointer;\n}\n\n.footer_second_page_column_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n  gap: 10px;\n  padding-top: 14px;\n}\n.quick_access_label_container {\n  list-style-type: none;\n  font-family: \"Lato\";\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.quick_access_label {\n  font-size: 18px;\n}\n\n.quick_access_label:hover {\n  color: #3498db !important;\n  text-decoration: underline !important;\n}\n.main_header {\n  font-size: 17px;\n  font-family: \"kufam\";\n  font-weight: bold;\n}\n.image_box {\n  width: 25px;\n}\n.footer-logo {\n  width: 100%;\n  cursor: pointer;\n}\n.footer_third_column_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-top: 13px;\n}\n.footer_third_column_image_container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n.social_media_tag {\n  font-size: 18px;\n}\n.copy_right_container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.social_media_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.copy_right_text {\n  font-size: 8px;\n  font-family: \"Kufam\";\n}\n.footer_mobile_view_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n.footer_mobile_second_column_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  gap: 30px;\n}\n.footer_mobile_third_column_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.drawer_close_icon {\n  height: 15px;\n  cursor: pointer;\n}\n.header_drawer_theme {\n  height: 55px;\n  color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.footer_page_menus {\n  all: unset;\n  cursor: pointer;\n}\n.user_profile_container {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.user_profile {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.lite_mode {\n  color: #fff;\n  font-weight: 600;\n}\n.black_text {\n  color: #111;\n  font-weight: 600;\n}\n\n.quick_access_bookmark_text {\n  cursor: pointer;\n  color: #fff; /* Default text color */\n}\n\n.quick_access_bookmark_text.selected {\n  font-weight: bold;\n  color: #f49d36; /* Change color to indicate selection */\n}\n.language_divider {\n  color: #fff;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.drawer_user_profile {\n  width: 30px !important;\n  height: 30px !important;\n  border-radius: 50% !important;\n  cursor: pointer;\n  object-fit: cover;\n}\n\n.main_menu {\n  color: white !important;\n  width: 100%;\n  background-color: transparent;\n  display: flex;\n  justify-content: end;\n}\n\n.segment_container {\n  display: flex;\n  align-items: center;\n  width: 190px;\n}\n\n.bookmarks-submenu .ant-menu-title-content {\n  color: #ffffff !important;\n}\n\n.submit_claim_modal > div > .ant-modal-content {\n  padding: 0px !important;\n}\n.header_drawer_close_container {\n  height: 6%;\n  color: #ffffff;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
